<template>
	<div class="flex-box">
		<div class="search-box">
			<div v-if="$hasPermission('A10403')">
				<label style="width: auto;" class="searchItemName">渠道：</label>
				<el-select v-model="SelectChannelId" clearable placeholder="筛选渠道">
					<el-option v-for="item in options" :key="item.id" :label="item.channelName" :value="item.id">
					</el-option>
				</el-select>
			</div>

			<div>
				<label class="searchItemName">设备号：</label>
				<el-input class="input-box" placeholder="筛选设备号后四位" v-model="queryParams.deviceCode" clearable>
				</el-input>
			</div>
			
			<div>
				<label class="searchItemName">缴费人：</label>
				<el-input class="input-box" placeholder="姓名" v-model="queryParams.idName" clearable>
				</el-input>
			</div>
			
			<div>
				<label class="searchItemName" style="width: 120px;">身份证后6位：</label>
				<el-input class="input-box" placeholder="身份证后6位" v-model="queryParams.idNumber" clearable maxlength="6" style="width: 150px;">
				</el-input>
			</div>
			
			<div>
				<label class="searchItemName">订单编号：</label>
				<el-input class="input-box" placeholder="系统业务号" v-model="queryParams.businessNo" clearable>
				</el-input>
			</div>
			
			<div>
				<label class="searchItemName" style="width: 140px;">支付平台订单号：</label>
				<el-input class="input-box" placeholder="支付平台订单号" v-model="queryParams.tradeNumber" clearable>
				</el-input>
			</div>

			<div>
				<label class="searchItemName">订单日期：</label>
				<el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
				</el-date-picker>
			</div>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="GetData()" icon="el-icon-search">查询</el-button>
			<!-- <el-button style="margin-left: 10px;" type="primary" v-on:click="$alert('测试')">测试</el-button> -->
		</div>
		<!--数据表格-->
		<div>
			<el-table :data="tableData" border style="width: 100%;margin: 15px 0px;">
				<el-table-column prop="orderNumber" label="订单编号" width="120" align="center">
				</el-table-column>
				<el-table-column prop="fee" label="订单金额" width="120" align="center">
					<template slot-scope="scope">
						{{scope.row.fee/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="payMethod" label="支付方式" width="100" align="center">
					<template slot-scope="scope">
						<el-tag
							:type="scope.row.payMethod === 1 ? 'success' : (scope.row.payMethod === 2 ?'':'info')"
							disable-transitions>{{scope.row.payMethod === 1 ? '微信' : (scope.row.payMethod === 2 ?'支付宝':'其它')}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="付款人" width="180" align="center">
					<template slot-scope="scope">
						<label>{{scope.row.idName}}</label>
						<br />
						<label>{{scope.row.idNumber.substring(0, 4)+"****"+scope.row.idNumber.substring(12)}}</label>
					</template>
				</el-table-column>
				<el-table-column prop="deviceCode" label="设备编号" width="140" align="center">
					<template slot-scope="scope">
						<span class="copyable-cell" :title="'双击复制：' + scope.row.deviceCode" @dblclick="copyToClipboard(scope.row.deviceCode)">{{ scope.row.deviceCode }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="channelName" label="渠道名称" width="180" align="center">
				</el-table-column>
				<el-table-column prop="payStatus" label="支付状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.payStatus ? 'success' : 'info'"
							disable-transitions>{{scope.row.payStatus ? '是':'否'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="shared" label="是否分账" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.shared ? 'success' : 'info'"
							disable-transitions>{{scope.row.shared ? '是':'否'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="businessType" label="支付业务类型" width="130" align="center">
					<template slot-scope="scope">
						<el-tag
							:type="getBusinessTypeTag(scope.row.businessType)"
							disable-transitions>{{getBusinessTypeText(scope.row.businessType)}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="tradeNumber" label="支付平台订单号" width="150" align="center">
					<template slot-scope="scope">
						<span class="copyable-cell" :title="'双击复制：' + scope.row.tradeNumber" @dblclick="copyToClipboard(scope.row.tradeNumber)">{{ scope.row.tradeNumber }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund" label="退款状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="getRefundTagType(scope.row.refund)"
							disable-transitions>{{getRefundStatusText(scope.row.refund)}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="体检时间" width="180" align="center">
				</el-table-column>
				<el-table-column prop="payTime" label="付款时间" width="180" align="center">
				</el-table-column>
				<el-table-column prop="address" label="操作" align="center" min-width="190" fixed="right">
					<template slot-scope="scope">
						<el-button v-if="$hasPermission('A10401')" v-show="!scope.row.payStatus" type="primary" size="mini" plain v-on:click="queryState(scope.row)">查询订单状态</el-button>
						<el-button v-if="$hasPermission('A10402')" v-show="scope.row.refund !== 1 && scope.row.payStatus" type="danger" size="mini" plain v-on:click="refund(scope.row)">退款</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
				:page-size="queryParams.pageSize" layout="sizes, prev, pager, next" :total="total">
			</el-pagination>
		</div>
		<!-- 退款选择弹窗 -->
		<el-dialog title="请选择退款类型" :visible.sync="showRefundDialog" width="420px" @close="onRefundDialogClose">
			<div>
				<el-input
					type="textarea"
					placeholder="请输入退款原因（不少于5个字符）"
					v-model="refundReason"
					:rows="3">
				</el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button v-show="showFullRefundButton" type="danger" @click="doRefund(1)" :disabled="!canSubmitRefund">退全款</el-button>
				<el-button v-show="showExamRefundButton" type="warning" @click="doRefund(2)" :disabled="!canSubmitRefund">退体检</el-button>
				<el-button v-show="showPhotoRefundButton" type="primary" @click="doRefund(3)" :disabled="!canSubmitRefund">退拍照</el-button>
				<el-button @click="showRefundDialog = false">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		post
	} from '../../../../public/request/request.js';
	export default {
		data() {
			return {
				/**
				 * 数据总条数
				 */
				total: 0,
				/**
				 * 接口查询参数
				 */
				queryParams: {
					/**
					 * 当前页码
					 */
					pageIndex: 1,
					/**
					 * 每页条数
					 */
					pageSize: 10,
					/**
					 * 渠道id
					 */
					channelId: 0,
					/**
					 * 设备号
					 */
					deviceCode: "",
					/**
					 * 体检人姓名
					 */
					idName: "",
					/**
					 * 身份证后6位
					 */
					idNumber: "",
					/**
					 * 订单号
					 */
					businessNo:"",
					/**
					 * 支付平台订单号
					 */
					tradeNumber:"",
					/**
					 * 开始日期,订单日期
					 */
					beginTime: '',
					/**
					 * 结束日期
					 */
					endTime: '',
				},
				/**
				 * 渠道下拉框
				 */
				options: [],
				/**
				 * 日期框快捷选项
				 */
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				/**
				 * 数据表格
				 */
				tableData: [],
				/**
				 * 退款弹窗
				 */
				showRefundDialog: false,
				refundReason: '',
				currentRefundModel: null
			}
		},
		/**
		 * 方法
		 */
		methods: {
			/**
			 * 双击复制到剪切板
			 */
			copyToClipboard(text) {
				const value = text == null ? '' : String(text).trim();
				if (!value) {
					this.$message.warning('无内容可复制');
					return;
				}
				const done = () => {
					this.$message.success('已复制到剪切板');
				};
				const fail = () => {
					this.$message.error('复制失败，请手动复制');
				};
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(value).then(done).catch(() => {
						this.copyToClipboardFallback(value) ? done() : fail();
					});
					return;
				}
				this.copyToClipboardFallback(value) ? done() : fail();
			},
			copyToClipboardFallback(text) {
				try {
					const textarea = document.createElement('textarea');
					textarea.value = text;
					textarea.setAttribute('readonly', '');
					textarea.style.position = 'fixed';
					textarea.style.left = '-9999px';
					document.body.appendChild(textarea);
					textarea.select();
					const ok = document.execCommand('copy');
					document.body.removeChild(textarea);
					return ok;
				} catch (e) {
					return false;
				}
			},
			/**
			 * 获取数据列表
			 */
			GetData() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});

				// 查询缴费信息数据列表
				post('405', this.queryParams)
					.then(response => {
						if (response.data.result == 0) {
							this.tableData = response.data.data.list;
							this.total = response.data.data.pageCount * this.queryParams.pageSize;
							loading.close();
						} else {
							this.$message.error('查询数据失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '查询数据失败');
					});
			},
			/**
			 * 获取渠道数据
			 */
			GetChannelData() {
				// 检查是否允许获取渠道数据
				const allowChannel = sessionStorage.getItem('allowChannel');
				if (allowChannel === 'false') {
					return; // 不允许获取渠道，直接返回
				}
				// 获取渠道数据列表
				post('208', {
						channelName: ''
					})
					.then(response => {
						if (response.data.result == 0) {
							this.options = response.data.data;
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 页码切换事件
			 */
			handleCurrentChange(pageIndex) {
				this.GetData();
			},
			/**
			 * 每页大小切换事件
			 */
			handleSizeChange(size) {
				this.queryParams.pageSize = size;
			},
			/**
			 * 日期转yyyy-MM-dd
			 * @param {Object} today日期
			 */
			dataToString(today) {
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			/**
			 * 打开加载遮罩
			 */
			openLoading() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				return loading;
			},
			/**
			 * 手动查询支付状态
			 */
			queryState(model){
				this.$confirm('是否手动查询支付状态?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const loading = this.openLoading();
					// 手动查询支付状态
					post('408', {
							objId: model.id
						})
						.then(response => {
							if (response.data.result == 0) {
								this.$message({
									message: '查询完成',
									type: 'success'
								});
								loading.close();
								this.GetData();
							} else {
								this.$message.error('操作失败：' + response.data.message);
								loading.close();
							}
						})
						.catch(error => {
							this.$message.error((error && error.userMessage) || '操作失败');
							loading.close();
						});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},
			/**
			 * 获取退款状态文本
			 */
			getRefundStatusText(refund) {
				switch(refund) {
					case 0:
						return '未退款';
					case 1:
						return '已全退款';
					case 2:
						return '已退体检';
					case 3:
						return '已退拍照';
					default:
						return '未知';
				}
			},
			getBusinessTypeText(t) {
				const map = {
					1: '体检',
					2: '驾驶证相片',
					3: '体检+拍照',
					4: '证件照',
					5: '健康证相片',
					6: '驾驶人体检表',
					7: '健康证申请表',
					8: '体检从业名单'
				};
				return map[t] || '未知';
			},
			getBusinessTypeTag(t) {
				if (t === 1 || t === 3) return 'success';
				if (t === 2) return '';
				if (t === 4 || t === 5) return 'warning';
				if (t >= 6 && t <= 8) return 'info';
				return 'danger';
			},
			/**
			 * 获取退款状态标签类型（颜色）
			 */
			getRefundTagType(refund) {
				switch(refund) {
					case 0:
						return 'info'; // 灰色，未退款
					case 1:
						return 'success'; // 橙色，已退体检
					case 2:
						return 'warning'; // 橙色，已退拍照
					case 3:
						return 'warning'; // 绿色，已全退款
					default:
						return 'info';
				}
			},
			/**
			 * 退款
			 */
			refund(model){
				this.currentRefundModel = model;
				this.refundReason = '';
				this.showRefundDialog = true;
			}
			,
			/**
			 * 执行退款
			 */
			doRefund(refundType){
				if (!this.canSubmitRefund) {
					this.$message.error('请输入不少于5个字符的退款原因');
					return;
				}
				const loading = this.openLoading();
				post('409', {
					orderId: this.currentRefundModel.id,
					reason: this.refundReason,
					refundType: refundType
				})
				.then(response => {
					if (response.data.result == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.showRefundDialog = false;
						loading.close();
						this.GetData();
					} else {
						this.$message.error('操作失败:' + response.data.message);
						loading.close();
					}
				})
				.catch(error => {
					this.$message.error((error && error.userMessage) || '操作失败');
					loading.close();
				});
			}
			,
			/** 关闭退款弹窗时重置 */
			onRefundDialogClose(){
				this.refundReason = '';
				this.currentRefundModel = null;
			}
		},
		/**
		 * 加载完成事件
		 */
		mounted() {
			this.GetChannelData();
			this.GetData();
		},
		/**
		 * 计算属性
		 */
		computed: {
			/** 退款原因是否可提交 */
			canSubmitRefund(){
				return this.refundReason && this.refundReason.length >= 5;
			},
			/** 业务类型是否支持全款退款：1~8 */
			supportFullRefundByBusinessType(){
				if (!this.currentRefundModel) {
					return false;
				}
				const t = this.currentRefundModel.businessType;
				return t >= 1 && t <= 8;
			},
			/** 业务类型是否支持体检/拍照退款：仅3 */
			supportSplitRefundByBusinessType(){
				if (!this.currentRefundModel) {
					return false;
				}
				return this.currentRefundModel.businessType === 3;
			},
			showFullRefundButton(){
				return this.currentRefundModel && this.currentRefundModel.refund === 0 && this.supportFullRefundByBusinessType;
			},
			showExamRefundButton(){
				return this.currentRefundModel && (this.currentRefundModel.refund === 0 || this.currentRefundModel.refund === 3) && this.supportSplitRefundByBusinessType;
			},
			showPhotoRefundButton(){
				return this.currentRefundModel && (this.currentRefundModel.refund === 0 || this.currentRefundModel.refund === 2) && this.supportSplitRefundByBusinessType;
			},
			/**
			 * 日期范围选择框
			 */
			dateRange: {
				get() {
					if (this.queryParams.beginTime == "" || this.queryParams.endTime == "") {
						const today = new Date();
						let year = today.getFullYear();
						let month = (today.getMonth() + 1).toString().padStart(2, '0');
						let day = today.getDate().toString().padStart(2, '0');
						this.queryParams.beginTime = `${year}-${month}-${day}`;
						this.queryParams.endTime = `${year}-${month}-${day}`;
					}
					return [new Date(Date.parse(this.queryParams.beginTime)), new Date(Date.parse(this.queryParams
						.endTime))];
				},
				set(value) {
					if (value == null) {
						const today = new Date();
						let year = today.getFullYear();
						let month = (today.getMonth() + 1).toString().padStart(2, '0');
						let day = today.getDate().toString().padStart(2, '0');
						this.queryParams.beginTime = `${year}-${month}-${day}`;
						this.queryParams.endTime = `${year}-${month}-${day}`;
					} else {
						this.queryParams.beginTime = this.dataToString(value[0]);
						this.queryParams.endTime = this.dataToString(value[1]);
					}
				}
			},
			/**
			 * 选择的渠道id
			 */
			SelectChannelId: {
				get() {
					if (this.queryParams.channelId == 0) {
						return '';
					} else {
						return this.queryParams.channelId;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelId = 0;
					} else {
						this.queryParams.channelId = value;
					}
				}
			}
		}
	}
</script>

<style>
	.flex-box {
		display: flex;
		flex-direction: column;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}

	.searchItemName {
		margin-left: 25px;
		text-align: right;
		display: inline-block;
	}

	.input-box {
		width: 200px;
	}

	.copyable-cell {
		cursor: copy;
		user-select: none;
	}
</style>